// extracted by mini-css-extract-plugin
export default {"pickupMap":"Onboarding_pickupMap__EezpB","field":"Onboarding_field__HHmTL","form":"Onboarding_form__PBY7W","fileInput":"Onboarding_fileInput__Mv5kA"};